import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Icon } from '../Elements';

import classes from './ItemArrow.module.scss';

const ItemArrow = ({ disabled }) => {
  return (
    <div className={cn(classes.button, disabled && classes.button_disabled)}>
      <Icon icon="arrow" className={classes.icon} size="32px" />
    </div>
  );
};

ItemArrow.propTypes = {
  disabled: PropTypes.bool
};

export default ItemArrow;
